export default __webpack_public_path__ + "static/media/pantry1-afterG-1440w.a0a972c0.webp";